// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  name: 'default',
  // API_URL: 'http://localhost:8000',
  // WEB_URL: 'http://localhost:8080',
  // API_URL: 'https://maknetic-be-uzcm36sala-ew.a.run.app',
  // WEB_URL: 'https://maknetic-fe-uzcm36sala-ew.a.run.app',
  //VERISON TEST con datos de produccion
  API_URL: 'https://test-maknetic-be-rxa7cyymcq-ew.a.run.app',
  WEB_URL: 'https://test-maknetic-fe-rxa7cyymcq-ew.a.run.app',


  // =============== PRODUCTION =============== //
  firebaseConfig: {
    apiKey: "AIzaSyAdYK2nK0FvncOFe09GChyWtAa7CJIFBgc",
    authDomain: "maknetic.firebaseapp.com",
    projectId: "maknetic",
    storageBucket: "maknetic.appspot.com",
    messagingSenderId: "717639941999",
    appId: "1:717639941999:web:e46e23e169a697ae5a329a"
  }

  // // =============== DEVELOPMENT =============== //
  // firebaseConfig: {
  //   apiKey: "AIzaSyD748tzZ1OcF0FH68PVFvay3fbP09EnC2s",
  //   authDomain: "maknetic-test.firebaseapp.com",
  //   projectId: "maknetic-test",
  //   storageBucket: "maknetic-test.appspot.com",
  //   messagingSenderId: "333262012403",
  //   appId: "1:333262012403:web:d6f2565a00e98916b51c86"
  // }
};
